function getComposedFieldName() {
  for (var _len = arguments.length, names = new Array(_len), _key = 0; _key < _len; _key++) {
    names[_key] = arguments[_key];
  }
  return names.filter(n => !!n && n !== null).join('.');
}

export { getComposedFieldName };
//# sourceMappingURL=formik.js.map
